import { Component, OnDestroy, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { WellHealthinessService } from 'app/modules/well-healthiness/services/well-healthiness.service';
import {
    HealthinessSummaryResponse,
    StringsHealthinessSummaryResponse,
} from 'app/modules/well-healthiness/model';
import { HealthinessInfoComponent } from 'app/modules/well-healthiness/components/healthiness-info/healthiness-info.component';
import { HealthinessChartComponent } from 'app/modules/well-healthiness/components/healthiness-chart/healthiness-chart.component';
import module from 'app/modules/well-healthiness/well-healthiness.module';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-well-healthiness-dashboard',
    templateUrl: './dashboard.page.html',
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [...module, HealthinessInfoComponent, HealthinessChartComponent],
    styleUrls: ['./dashboard.page.scss'],
})
export class DashboardPage implements OnDestroy {
    wellsHealthinessSummary: HealthinessSummaryResponse | undefined;
    stringsHealthinessSummary: StringsHealthinessSummaryResponse | undefined;
    selectedWellHealthinessStatus: string | null = null;
    private readonly _unsubscribeAll = new Subject<void>();

    constructor(
        public service: WellHealthinessService,
        private readonly router: Router,
        private readonly route: ActivatedRoute,
    ) {
        this.service
            .getWellsHealthinessSummary()
            .subscribe((response: HealthinessSummaryResponse) => {
                if (response?.riskRankingItems) {
                    const sortOrder = [
                        'healthy no risk',
                        'healthy low risk',
                        'healthy medium risk',
                        'unhealthy high risk',
                        'unhealthy very high risk'
                    ];
                    response.riskRankingItems.sort((a, b) => {
                        const indexA = sortOrder.indexOf(a.category.toLowerCase());
                        const indexB = sortOrder.indexOf(b.category.toLowerCase());
                        const valA = indexA === -1 ? 999 : indexA;
                        const valB = indexB === -1 ? 999 : indexB;
                        return valA - valB;
                    });
                }
                this.wellsHealthinessSummary = response;
            });

        this.service
            .getStringsHealthinessSummary()
            .subscribe((response: StringsHealthinessSummaryResponse) => {
                this.stringsHealthinessSummary = response;
            });

        this.route.queryParamMap
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((params) => {
                this.selectedWellHealthinessStatus =
                    params.get('WellHealthinessStatus') ?? null;
            });
    }

    onCategorySelected(category: string): void {
        this.router.navigate(['/wim/well-healthiness/dashboard/string'], {
            queryParams: {
                WellHealthinessStatus: category,
            },
            queryParamsHandling: 'merge',
            replaceUrl: true
        }).then(() => {
            setTimeout(() => {
                const element = document.getElementById('string-summary-section');
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                }
            }, 50);
        });
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }
}
